import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { Field } from 'react-final-form';
import cx from 'classnames';
import Form from '@piconetworks/pkg-form';
import NewsletterCheckbox from './NewsletterCheckbox.js';
import styles from './scss/ChooseNewsletter.module.scss.js';

var _excluded = ["fieldContainerProps", "description", "required", "newsletters", "containerType", "disableGroup", "newsletterFilter", "onHasNewsletters", "onHasNoNewsletters", "isSingleColumn", "isReadyToMount", "linkColor", "defaultValue", "previewMode", "showMore"];
var FILTER_TYPES = {
  free: 'free',
  preselected: 'preselected',
  paid: 'paid',
  all: 'all'
};
var ChooseNewsletter = function ChooseNewsletter(_ref) {
  if (_ref === void 0) {
    _ref = {};
  }
  var _ref2 = _ref,
    fieldContainerProps = _ref2.fieldContainerProps,
    _ref2$description = _ref2.description,
    description = _ref2$description === void 0 ? null : _ref2$description,
    required = _ref2.required,
    _ref2$newsletters = _ref2.newsletters,
    newsletters = _ref2$newsletters === void 0 ? [] : _ref2$newsletters,
    containerType = _ref2.containerType,
    disableGroup = _ref2.disableGroup,
    _ref2$newsletterFilte = _ref2.newsletterFilter,
    newsletterFilter = _ref2$newsletterFilte === void 0 ? 'all' : _ref2$newsletterFilte,
    _ref2$onHasNewsletter = _ref2.onHasNewsletters,
    onHasNewsletters = _ref2$onHasNewsletter === void 0 ? function () {} : _ref2$onHasNewsletter,
    _ref2$onHasNoNewslett = _ref2.onHasNoNewsletters,
    onHasNoNewsletters = _ref2$onHasNoNewslett === void 0 ? function () {} : _ref2$onHasNoNewslett,
    _ref2$isSingleColumn = _ref2.isSingleColumn,
    isSingleColumn = _ref2$isSingleColumn === void 0 ? true : _ref2$isSingleColumn,
    isReadyToMount = _ref2.isReadyToMount,
    _ref2$linkColor = _ref2.linkColor,
    linkColor = _ref2$linkColor === void 0 ? '' : _ref2$linkColor,
    _ref2$defaultValue = _ref2.defaultValue,
    defaultValue = _ref2$defaultValue === void 0 ? [] : _ref2$defaultValue,
    previewMode = _ref2.previewMode,
    _ref2$showMore = _ref2.showMore,
    showMore = _ref2$showMore === void 0 ? false : _ref2$showMore,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded);
  if (!isReadyToMount) {
    return null;
  }
  var _useState = useState(newsletterFilter),
    filter = _useState[0],
    setFilter = _useState[1];
  useEffect(function () {
    if (showMore) {
      setFilter(defaultValue.length ? FILTER_TYPES.preselected : FILTER_TYPES.free);
    }
  }, []);
  var filteredNewsletters = newsletters.filter(function (newsletter) {
    if (newsletter === undefined || newsletter === null) {
      return false;
    } else {
      var id = newsletter.id,
        type = newsletter.type;
      var freeNewsletters = type === FILTER_TYPES.free;
      var paidNewsletters = type === FILTER_TYPES.paid;
      if (filter === FILTER_TYPES.all) {
        return true;
      }

      // If no default newsletter id is provided, we show only free newsletters
      if (filter === FILTER_TYPES.free || !(defaultValue !== null && defaultValue !== void 0 && defaultValue.length)) {
        return freeNewsletters;
      }
      if (filter === FILTER_TYPES.preselected) {
        return freeNewsletters && (defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.includes(id));
      }
      if (filter === FILTER_TYPES.paid) {
        return paidNewsletters;
      }
      return false;
    }
  });
  var disabledNewsletters = 0;
  var Newsletters = filteredNewsletters.map(function (newsletter, index) {
    var _cx;
    var enabled = newsletter.enabled,
      type = newsletter.type;
    var isDisabled = type !== FILTER_TYPES.free && enabled !== true;
    if (isDisabled) {
      disabledNewsletters++;
    }

    // name is to support ChooseNewsletter, but the semantic naming should be label
    // because Field also takes a name prop
    var revisedNewsletter = Object.assign({}, newsletter, {
      label: newsletter.name
    });
    return /*#__PURE__*/React.createElement(Field, _extends({
      name: "newsletters",
      component: NewsletterCheckbox,
      type: "checkbox"
    }, required && {
      validate: function validate(value) {
        return value ? undefined : 'Required';
      }
    }, {
      className: cx((_cx = {}, _cx[styles.checkboxMenu] = containerType === 'dropdown', _cx)),
      disabled: isDisabled || disableGroup,
      value: (newsletter === null || newsletter === void 0 ? void 0 : newsletter.id) || (newsletter === null || newsletter === void 0 ? void 0 : newsletter.value),
      key: index,
      isSingleColumn: isSingleColumn,
      linkColor: linkColor,
      newsletter: revisedNewsletter,
      showIcon: isDisabled,
      noTooltip: previewMode,
      previewMode: previewMode
    }, rest));
  });
  if (filteredNewsletters.length - disabledNewsletters > 0) {
    var _cx2;
    onHasNewsletters();
    return /*#__PURE__*/React.createElement(Form.Field, _extends({}, fieldContainerProps, {
      style: {
        marginBottom: 0
      }
    }), /*#__PURE__*/React.createElement("p", null, description), /*#__PURE__*/React.createElement("div", null, Newsletters, showMore && defaultValue.length && newsletters.length > defaultValue.length ? /*#__PURE__*/React.createElement("div", {
      className: styles.showMore,
      onClick: function onClick() {
        setFilter(filter === FILTER_TYPES.preselected ? FILTER_TYPES.free : FILTER_TYPES.preselected);
      }
    }, "Show " + (filter === FILTER_TYPES.preselected ? 'more' : 'less'), /*#__PURE__*/React.createElement("svg", {
      className: cx((_cx2 = {}, _cx2[styles.isInverse] = filter === 'free', _cx2)),
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24"
    }, /*#__PURE__*/React.createElement("g", {
      fill: "none"
    }, /*#__PURE__*/React.createElement("g", {
      fill: "" + (linkColor || '#120A20')
    }, /*#__PURE__*/React.createElement("path", {
      d: "M5.3 8.3C5.7 7.9 6.3 7.9 6.7 8.3L12 13.6 17.3 8.3C17.7 7.9 18.3 7.9 18.7 8.3 19.1 8.7 19.1 9.3 18.7 9.7L12.7 15.7C12.3 16.1 11.7 16.1 11.3 15.7L5.3 9.7C4.9 9.3 4.9 8.7 5.3 8.3Z"
    }))))) : ''));
  } else {
    onHasNoNewsletters();
  }
  return null;
};
ChooseNewsletter.propTypes = {
  newsletters: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string
  })),
  containerType: PropTypes.string,
  disableGroup: PropTypes.bool,
  newsletterFilter: PropTypes.string,
  onHasNewsletters: PropTypes.func,
  onHasNoNewsletters: PropTypes.func,
  isSingleColumn: PropTypes.bool,
  isReadyToMount: PropTypes.bool.isRequired,
  defaultValue: PropTypes.array,
  linkColor: PropTypes.string,
  fieldContainerProps: PropTypes.shape({
    label: PropTypes.string,
    required: PropTypes.boolean
  }),
  description: PropTypes.string,
  required: PropTypes.func,
  previewMode: PropTypes.bool
};

export { ChooseNewsletter as default };
//# sourceMappingURL=index.js.map
